import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'

export const INTERESTS_QUERY_KEY = ['knowledge', 'interests'] as const

/** Centres d'intérêt actuels de l'utilisateur authentifié (SPEC §6.2, §12). */
export function useInterests() {
  return useQuery({
    queryKey: INTERESTS_QUERY_KEY,
    queryFn: () => practiceApi.fetchInterests().then((response) => response.data.data),
    staleTime: 60_000,
  })
}

/**
 * Remplace intégralement la sélection de centres d'intérêt — utilisé par
 * l'étape « matières d'intérêt » de l'onboarding (SPEC §6.2, §12).
 */
export function useUpdateInterests() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (topicIds: string[]) => practiceApi.updateInterests(topicIds).then((response) => response.data.data),
    onSuccess: (interests) => {
      queryClient.setQueryData(INTERESTS_QUERY_KEY, interests)
    },
  })
}
